var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "customSelect", on: { click: _vm.handleClick } },
    [
      _c(
        "div",
        { staticClass: "select_wrap" },
        [
          !_vm.data.length
            ? [
                _c("span", { staticClass: "placeholder" }, [
                  _vm._v(_vm._s(_vm.placeholder)),
                ]),
              ]
            : _vm._l(_vm.data, function (item, index) {
                return _c(
                  "el-tag",
                  {
                    key: item.label + item[_vm.keyValue] + index,
                    class: item.tagClass,
                    attrs: {
                      "disable-transitions": "",
                      size: "mini",
                      closable: "",
                    },
                    on: {
                      close: function ($event) {
                        if ($event.target !== $event.currentTarget) return null
                        return _vm.handleClose(item)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.label))]
                )
              }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }